/* LUS · Product page: gallery, variant switch, sticky buy bar. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function gallery(root) {
    var slides = [].slice.call(root.querySelectorAll('.pg-slide'));
    var thumbs = [].slice.call(root.querySelectorAll('.pg-th'));
    var count = root.querySelector('.pg-count b');
    if (slides.length < 1) return;
    var i = 0;

    // Videos: only the slide on screen plays (muted, looped); every other one is
    // paused. Before this, only a first-slide video had autoplay and nothing ever
    // started the rest, so a video further down the gallery just sat there.
    function syncVideo(s, active) {
      var v = s && s.querySelector('video');
      if (!v) return;
      if (active) {
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        if (v.preload !== 'auto') v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    }

    slides.forEach(function (s, k) {
      var v = s.querySelector('video');
      if (!v) return;
      v.setAttribute('preload', k === 0 ? 'auto' : 'metadata');
      v.setAttribute('disablepictureinpicture', '');
      if (thumbs[k]) thumbs[k].classList.add('is-vid');
      // tap / click the video to pause or resume it
      v.addEventListener('click', function () {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    });

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('on', k === i);
        syncVideo(s, k === i);
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('on', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (count) count.textContent = String(i + 1);
      var act = thumbs[i];
      if (act && act.parentNode && act.parentNode.scrollWidth > act.parentNode.clientWidth) {
        var p = act.parentNode;
        var want = act.offsetLeft - (p.clientWidth - act.offsetWidth) / 2;
        p.scrollTo({ left: Math.max(0, want), behavior: 'smooth' });
      }
      [i + 1, i - 1].forEach(function (k) {
        var s = slides[(k + slides.length) % slides.length];
        var img = s && s.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    }

    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(k); }
      });
    });
    var prev = root.querySelector('.pg-nav.prev');
    var next = root.querySelector('.pg-nav.next');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    if (slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
    });

    var x0 = null;
    var stage = root.querySelector('.pg-stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 42) show(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });
    }

    show(0);
  }

  function variants(root) {
    var vals = [].slice.call(root.querySelectorAll('.pb-val[data-vid]'));
    if (vals.length < 2) return;
    var ids = [].slice.call(document.querySelectorAll('input[name="id"]'));
    var now = root.querySelector('.pb-now');
    var was = root.querySelector('.pb-was');
    var save = root.querySelector('.pb-save');
    var barNow = document.querySelector('.pdp-bar-p b');
    var barWas = document.querySelector('.pdp-bar-p s');

    vals.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('off')) return;
        vals.forEach(function (o) { o.classList.toggle('on', o === b); });
        ids.forEach(function (inp) { inp.value = b.dataset.vid; });
        if (now && b.dataset.price) now.textContent = b.dataset.price;
        if (barNow && b.dataset.price) barNow.textContent = b.dataset.price;
        [was, barWas].forEach(function (el) {
          if (!el) return;
          if (b.dataset.was) { el.textContent = b.dataset.was; el.hidden = false; }
          else el.hidden = true;
        });
        if (save) {
          if (b.dataset.save) { save.textContent = b.dataset.save; save.hidden = false; }
          else save.hidden = true;
        }
        if (history.replaceState) {
          var u = new URL(location.href);
          u.searchParams.set('variant', b.dataset.vid);
          history.replaceState({}, '', u);
        }
      });
    });
  }

  function stickyBar() {
    var bar = document.querySelector('.pdp-bar');
    var anchor = document.querySelector('.pb-acts');
    if (!bar || !anchor) return;

    // The site header is .navbar; fall back to whatever sticky element sits on top.
    var nav = document.querySelector('.navbar');
    function setNavH() {
      var h = nav ? Math.round(nav.getBoundingClientRect().height) : 0;
      bar.style.setProperty('--navh', (h > 20 && h < 160 ? h : 56) + 'px');
    }

    var tick = false;
    function update() {
      tick = false;
      // Show once the real buttons have scrolled out of the top of the viewport,
      // and hide again near the very bottom so it never fights the footer.
      var r = anchor.getBoundingClientRect();
      var navH = nav ? nav.getBoundingClientRect().height : 56;
      var past = r.bottom < navH + 8;
      var atEnd = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 120);
      bar.classList.toggle('on', past && !atEnd);
    }
    function onScroll() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(update);
    }

    setNavH();
    update();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () { setNavH(); onScroll(); }, { passive: true });
  }

  ready(function () {
    document.querySelectorAll('.pg').forEach(gallery);
    document.querySelectorAll('.pb').forEach(variants);
    stickyBar();
  });
})();
